"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimplicityProvider = void 0;
const simplicity_data_provider_1 = require("./simplicity-data-provider");
class SimplicityProvider {
    constructor() {
        this.alreadyBuilt = false;
    }
    get instance() {
        if (!this._instance) {
            throw new TypeError('This instance has not been built yet - Please call .build() before .instance');
        }
        return this._instance;
    }
    withOptions(options) {
        this._options = options;
        return this;
    }
    build() {
        if (this.alreadyBuilt) {
            throw new TypeError('This instance has already been built');
        }
        this._instance = new simplicity_data_provider_1.SimplicityDataProviderImpl(this._options);
        this.alreadyBuilt = true;
        return this._instance;
    }
}
exports.SimplicityProvider = SimplicityProvider;
